// extracted by css-extract-rspack-plugin
export default {"dealerSelect":"XpXnBgh3dPInNKSn","dealerName":"RpDonOouEPwSZNB_","dealerPopover":"rGB5nY4o_usyU4vs"};